import { ShipWheelIcon } from './ShipWheelIcon';

/**
 * author: Google
 * id 1F35A20C-CF6C-4C2A-9A72-82269F4ECCF7
 * name ship-wheel
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ship-wheel.svg
 * tags
 * - Transportation + Water 
 */
export const VoyagerIcon = ShipWheelIcon;
export default VoyagerIcon